// JsFromRoutes CacheKey 3be8e9d35c5c383f5365d8c92afc1335
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper(
    "get",
    "/api/:venue_slug/sponsorships/:sponsorship_id/tasks"
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/api/:venue_slug/sponsorships/:sponsorship_id/tasks"
  ),
  show: /* #__PURE__ */ definePathHelper(
    "get",
    "/api/:venue_slug/sponsorships/:sponsorship_id/tasks/:id"
  ),
  update: /* #__PURE__ */ definePathHelper(
    "patch",
    "/api/:venue_slug/sponsorships/:sponsorship_id/tasks/:id"
  ),
  destroy: /* #__PURE__ */ definePathHelper(
    "delete",
    "/api/:venue_slug/sponsorships/:sponsorship_id/tasks/:id"
  ),
}
